import { nextTick, reactive, computed } from "vue";
import { merge } from "lodash-es";
export const routerScrollState = reactive({
    routeScroll: null
});
export function useRouteScroll() {
    const routeScrollParam = computed(() => {
        return routerScrollState.routeScroll;
    });
    async function scrollIntoElement(manualOptions) {
        if (!manualOptions && !routerScrollState.routeScroll)
            return;
        const defaultOptions = {
            block: "center",
            behavior: "auto",
            disableHighlight: false
        };
        let options = null;
        if (manualOptions) {
            options = merge({}, defaultOptions, manualOptions !== null && manualOptions !== void 0 ? manualOptions : routerScrollState.routeScroll);
        }
        else {
            if (Array.isArray(routerScrollState.routeScroll)) {
                options = merge({}, defaultOptions, routerScrollState.routeScroll[0]);
                routerScrollState.routeScroll.splice(0, 1);
            }
            else {
                options = merge({}, defaultOptions, routerScrollState.routeScroll);
            }
        }
        routerScrollState.routeScroll = null; // clear it
        await nextTick(); // wait for a bit
        const el = document.querySelector(options.querySelector);
        window.requestAnimationFrame(() => {
            if (el) {
                // ensures it will scroll in next animation frame
                el.scrollIntoView({ block: options.block, behavior: options.behavior });
                if (!options.disableHighlight) {
                    highlightElement(el);
                }
            }
            if (options.triggerClickButtonSelector) {
                const button = document.querySelector(options.triggerClickButtonSelector);
                if (button) {
                    button.click();
                }
            }
        });
    }
    function highlightElement(el) {
        // May contain class with !important which needs to be removed to have highlight effect work
        const oldClassName = el.className;
        el.addEventListener("animationend", () => {
            el.className = oldClassName; // restore old class names after CSS highliht animation is done
        }, { passive: true, once: true });
        el.className = "alert-notice";
    }
    return { scrollIntoElement, highlightElement, routeScrollParam };
}
